import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { ListItemText, ListItem, List, Typography, Grid, Checkbox } from '@material-ui/core';
import { isEmpty as isArrayEmpty } from 'front-onceforall-core/dist/utils/arrays';
import { DOCUMENT_CATEGORY } from '../../../../utils/constant';
import styles from './styles';
import CustomInputs from './CustomInputs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function DocumentGrid(_ref) {
  let {
    category,
    documentTypes,
    ...props
  } = _ref;
  const docs = documentTypes.filter(doc => doc.category === category);
  const isMandatoryCategory = category === DOCUMENT_CATEGORY.MANDATORY;
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    spacing: 2,
    children: /*#__PURE__*/_jsxs(Grid, {
      item: true,
      xs: 12,
      md: props.isOnEdit ? undefined : 6,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        children: /*#__PURE__*/_jsx(Translate, {
          value: `project.documents.${category.toLowerCase()}Documents`
        })
      }), /*#__PURE__*/_jsx("div", {
        children: !isArrayEmpty(documentTypes) && /*#__PURE__*/_jsxs(List, {
          dense: true,
          style: styles.container,
          children: [docs.map(doc => /*#__PURE__*/_jsxs(ListItem, {
            alignItems: "flex-start",
            children: [/*#__PURE__*/_jsx(ListItemText, {
              "data-id": `label-${doc.code}`,
              value: doc.code,
              style: styles.item,
              primary: /*#__PURE__*/_jsx(Typography, {
                variant: "body2",
                children: doc.label
              }),
              disableTypography: true
            }), /*#__PURE__*/_jsx(Checkbox, {
              "data-id": `check-${doc.code}`,
              onChange: isMandatoryCategory ? () => {} : () => props.onCheckboxChange(doc),
              checked: isMandatoryCategory || Boolean(doc.requiredInProject),
              disabled: isMandatoryCategory
            })]
          }, doc.code)), category === DOCUMENT_CATEGORY.SPECIFIC && /*#__PURE__*/_jsx(CustomInputs, {
            onChangeLabel: props.onChangeLabel,
            onRemoveCustom: props.onRemoveCustom,
            onCheckboxChange: props.onCheckboxChange,
            onAddCustom: props.onAddCustom,
            isOnEdit: props.isOnEdit,
            customDocs: documentTypes.filter(doc => doc.category === DOCUMENT_CATEGORY.CUSTOM)
          })]
        })
      })]
    })
  });
}
DocumentGrid.defaultProps = {
  isOnEdit: false,
  documentTypes: []
};
DocumentGrid.propTypes = {
  onChangeLabel: PropTypes.func.isRequired,
  onRemoveCustom: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onAddCustom: PropTypes.func.isRequired,
  isOnEdit: PropTypes.bool,
  documentTypes: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    requiredInProject: PropTypes.bool.isRequired
  })),
  category: PropTypes.string.isRequired
};
export default DocumentGrid;